import React, { useRef } from "react";
import SectionTitle from "@src/components/SectionTitle";
import Button from "@src/components/Button";
import useFadeIn from "@src/hooks/useFadeIn";
import styles from "./index.module.scss";
import beyondData from "./assets/beyond-data.svg";
import beyondBlockchains from "./assets/beyond-blockchains.svg";
import beyondDataMobile from "./assets/beyond-data-s.svg";
import beyondBlockchainsMobile from "./assets/beyond-blockchains-s.svg";

const title = "From trusted systems to trustless execution";
const learnMoreLink = "https://github.com/primus-labs/skills";

const cards = [
  {
    title: "Verification Beyond Data",
    content:
      "Verification is no longer just about data. It now includes real-world actions executed by AI agents.",
  },
  {
    title: "Trust Beyond Blockchains",
    content:
      "As AI agents execute real-world actions, trust must extend beyond blockchain transactions into connected systems.",
  },
];

export default () => {
  const ref = useRef(null);
  const [visible] = useFadeIn(ref);

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionTitle transition ref={ref} visible={visible} className={styles.title}>
            {title}
          </SectionTitle>
          <Button link={learnMoreLink} className={styles.button} isDark>
            Explore Skills
          </Button>
        </div>

        <div className={styles.cards}>
          {cards.map((card, index) => (
            <div key={card.title} className={styles.card}>
              <img
                src={index === 0 ? beyondData : beyondBlockchains}
                alt={card.title}
                className={styles.iconDesktop}
              />
              <img
                src={index === 0 ? beyondDataMobile : beyondBlockchainsMobile}
                alt={card.title}
                className={styles.iconMobile}
              />
              <div className={styles.cardBody}>
                <div className={styles.cardTitle}>{card.title}</div>
                <div className={styles.cardContent}>{card.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
